<template>
  <q-tabs v-model="tab" dense class="nav-tabs" active-color="primary" indicator-color="primary" align="left"
    narrow-indicator>
    <q-tab v-for="(item, index) in buildParties" :name="item.orderParty.resourceUid"
      :label="$t( item.orderParty?.role?.resourceUid ? `demand.party.roles.${item.orderParty?.role?.resourceUid}` : `demand.party.roles.SELLER` )" :key="index" class="nav nav-item flex-grow-0" />
  </q-tabs>

  <q-tab-panels v-model="tab">
    <q-tab-panel v-for="(item, index) in buildParties" :name="item.orderParty.resourceUid" :key="index"
      class="p-0 pt-3">
      <div v-if="item.orderParty.party.objectType.includes('frenchperson')">
        <SummaryPerson :person="item.orderParty.third.person" :order="'order'"/>
      </div>
      <div v-else>
        <SummaryOrganization :organization="item.orderParty.third.organization" :order="'order'"/>
      </div>
    </q-tab-panel>
  </q-tab-panels>
</template>

<script lang="ts">
import SummaryPerson from "@/components/summary-panel/SummaryPerson.vue";
import SummaryOrganization from "@/components/summary-panel/SummaryOrganization.vue";
import { Options, Vue } from "vue-class-component";
import { OfferAssociatedParty, Order, OrderAssociatedParty } from "@/types";

@Options({
  components: { SummaryPerson, SummaryOrganization },
  props: ["arrParties"],
})
export default class OrderSummaryParty extends Vue {
  arrParties?: Array<OrderAssociatedParty>;
  tab?: string = "";
  filteredParties?: Array<OrderAssociatedParty>;
  get buildParties() {
    if (this.arrParties) {
      this.filteredParties = this.arrParties.filter((el) => el.orderParty?.role?.resourceUid !== "DIRG");
      if (this.filteredParties.length>0){
        this.tab = this.filteredParties[0].orderParty?.resourceUid;
      }
      return this.filteredParties;
    }
    return [];
  }
}
</script>
